import { render, staticRenderFns } from "./DisplayKwicHeaderCheck.vue?vue&type=template&id=69873a6b&scoped=true&"
import script from "./DisplayKwicHeaderCheck.vue?vue&type=script&lang=js&"
export * from "./DisplayKwicHeaderCheck.vue?vue&type=script&lang=js&"
import style0 from "./DisplayKwicHeaderCheck.vue?vue&type=style&index=0&id=69873a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.8.3_css-loader@3.6.0_lodash@4.17.21_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69873a6b",
  null
  
)

export default component.exports